export default "__VITE_ASSET__BsPPn1MY__"